﻿function setAds() {
    if (window.fallbackLeft) {
        let windowWidth = $(document).width();
        let $body = $('body');
        $body.addClass('takeover-active');
        let $takeOverLeft = $("#takeOverLeft");
        if (windowWidth >= 976) {
            $body.addClass('desktop-takeover');
            $body.removeClass('small-takeover');
            if ($takeOverLeft.html().trim().length === 0) {
                    $takeOverLeft.html(getFallBackHtml(fallbackLeft, clickTag));
                    $("#takeOverTop").html(getFallBackHtml(fallBackTop, clickTag));
                    $("#takeOverRight").html(getFallBackHtml(fallBackRight, clickTag));                
            }
        } else { // just fix the leaderboard container so its with you at all times
            $body.removeClass('desktop-takeover');
            $body.addClass('small-takeover');
            $takeOverLeft.html('');
            $("#takeOverTop").html('');
            $("#takeOverRight").html('');
        }
    }
}

function getFallBackHtml(file, link) {
    return $(`<a href='${link}' target='_blank'><img src='${file}' /></a>`);
}

function fixAdOnScroll() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        if ($(window).scrollTop() > 100) {
            if (!$("#top-leaderboard").hasClass('ad-scroll-fix')) {
                $("#top-leaderboard").addClass('ad-scroll-fix');
            }
        } else {
            $("#top-leaderboard").removeClass('ad-scroll-fix');
        }
    }
}

function stickyInline01() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        $("#top-leaderboard").removeClass('sticky-dfp-ad');
    }
}

export function setupAdTakeover() {
    $(window).resize(function () {
        setAds();
    });
    //$(document).on('load', fixAdOnScroll);
    //$(document).on('resize', fixAdOnScroll);
    $(document).on("scroll", fixAdOnScroll);
    stickyInline01();

    window.setTakeover = function (leftswf, topswf, rightswf, fallbackLeft, fallBackTop, fallBackRight, clickTag) {
        window.leftswf = leftswf;
        window.topswf = topswf;
        window.rightswf = rightswf;
        window.fallbackLeft = fallbackLeft;
        window.fallBackTop = fallBackTop;
        window.fallBackRight = fallBackRight;
        window.clickTag = clickTag;
        setAds();
        $(window).resize();
    }
}
